import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

function StaticBody() {
	return (
		<>
			<p>
				<Trans i18nKey="loan_agreement_guarantor_lender.static_body_default">
					<strong>DEFAULT.</strong>
					If the BORROWER fails to pay the Loan and interest according to the terms of the Agreement, the
					LENDER may demand from the GUARANTOR to pay the Loan and interest on behalf of the BORROWER and the
					GUARANTOR shall pay the LENDER the Loan and interest.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_lender.static_body_warranties">
					<strong>WARRANTIES.</strong>
					The obligation of the GUARANTOR is presumed valid and binding until Philippine courts say that the
					Agreement and/or this Accession is void, invalid, or unenforceable. Also, the GUARANTOR only
					guarantees payment of the Loan and interest but not any future debts of the BORROWER. If the
					GUARANTOR pays for the Loan and interest, the LENDER can no longer demand payment from the BORROWER.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_lender.static_body_termination">
					<strong>TERMINATION.</strong>
					This Accession shall end when the Loan and interest has been fully paid.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_lender.static_body_compromise">
					<strong>COMPROMISE.</strong>
					If the LENDER and the BORROWER enter into a compromise, the GUARANTOR can benefit from, but cannot
					be harmed by, that compromise. On the other hand, if the LENDER and the GUARANTOR enter into a
					compromise, the BORROWER can benefit from, but cannot be harmed by, that compromise.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_lender.static_body_entire">
					<strong>ENTIRE AGREEMENT.</strong>
					All the agreed terms and conditions between the GUARANTOR and the LENDER are in this Accession.
					References to the Loan shall be based on the Loan Agreement Promissory Note to which this Accession
					is attached. If the PARTIES want to make changes to this Accession, they must write down those
					changes and sign that document. When both PARTIES have signed that document, the agreed changes
					automatically change and become part of this Accession.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_lender.static_body_governing_law">
					<strong>GOVERNING LAW.</strong>
					Philippine law governs this Agreement.
				</Trans>
			</p>
			<p className="page-break"></p>
			<p>
				<Trans i18nKey="loan_agreement_guarantor_lender.static_body_venue">
					<strong>VENUE AND PLACE OF PAYMENT.</strong>
					The PARTIES agree that if there is a problem or disagreement about this Accession, they will try
					their best to discuss the problem and work together to fix it. But if they cannot fix the problem
					and the LENDER and/or the GUARANTOR must go to court, they can only file a case with the courts that
					has jurisdiction over the place WHERE THE LENDER LIVES.
				</Trans>
			</p>

			<p>
				<Trans i18nKey="loan_agreement_guarantor_lender.static_body_venue_bottom">
					The PARTIES have agreed that neither of them can go to any other court.
				</Trans>
			</p>
		</>
	);
}

export default hot(module)(withTranslation()(StaticBody));
